import { ListBox } from "primereact/listbox";
import { useState } from "react";
import { feeTypesApi } from "../../services/nomenclatures/feeTypesApi";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { useAppDispatch } from "../../hooks/redux";
import { getSelectedFees, setSelectedFees } from "../../services/students/studentsSlice";
import { useSelector } from "react-redux";
import FilterCard from "./FilterCard";

const FeeFilter = (props: any) => {
  const selectedFees = useSelector(getSelectedFees);
  const dispatch = useAppDispatch();

  const { data: feeType, error, isLoading } = feeTypesApi.useGetFeeTypesQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Message severity="error" text={JSON.stringify(error)} />;

  return (
    <FilterCard title="По такса:">
      <ListBox
        value={selectedFees}
        onChange={(e) => dispatch(setSelectedFees(e.value))}
        options={feeType?.data ?? []}
        itemID="feeTypeId"
        optionLabel="name"
        filterPlaceholder=""
        emptyFilterMessage="Няма намерени резултати."
        multiple
        listClassName="max-h-24rem"
      />
    </FilterCard>
  );
};

export default FeeFilter;
